module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-wap"
  }, [(_vm.showBack) ? _c('div', {
    staticClass: "back-box",
    attrs: {
      "data-track": _vm.backTrack
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "src": require("./../assets/images/home/back-icon.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showHome) ? _c('div', {
    staticClass: "home-box",
    attrs: {
      "data-track": _vm.homeTrack ? _vm.homeTrack : 'djk_kj_lessons_kjhomepage'
    },
    on: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_c('img', {
    staticClass: "home",
    attrs: {
      "src": require("./../assets/images/icon/home@2x.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.showBack ? 'tit' : 'tit tit-w1'],
    style: (_vm.showHome ? 'width:52%' : '')
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showUser) ? _c('div', {
    staticClass: "user-box",
    attrs: {
      "data-track": "djk-kj-home_personalcenter"
    },
    on: {
      "click": function($event) {
        _vm.goMy()
      }
    }
  }, [_c('img', {
    staticClass: "user",
    attrs: {
      "src": require("./../assets/images/home/user-icon.png")
    }
  })]) : (_vm.isFenXiao) ? _c('div', {
    staticClass: "broker-box",
    on: {
      "click": function($event) {
        _vm.goBroker()
      }
    }
  }, [_c('img', {
    staticClass: "broker",
    attrs: {
      "src": require("./../assets/images/home/fenxiao@3x.png")
    }
  }), _vm._v(" "), (_vm.showPrice) ? _c('p', {
    staticClass: "explain"
  }, [_vm._v("分享赚￥" + _vm._s(_vm.course.distributionPrice))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showSubmitBtn) ? _c('div', {
    staticClass: "submit-box",
    on: {
      "click": _vm.bindSubmit
    }
  }, [_c('div', {
    staticClass: "submit-btn"
  }, [_vm._v("提交")])]) : _vm._e(), _vm._v(" "), (_vm.isFenXiao && _vm.shareMask && _vm.showMask) ? _c('div', {
    staticClass: "fenxiao-mask",
    on: {
      "click": _vm.hideMask
    }
  }, [_c('img', {
    staticClass: "fenxiao-image",
    attrs: {
      "src": _vm.shareMask
    }
  }), _vm._v(" "), _c('p', [_vm._v("长按保存图片并将图片发送给好友")])]) : _vm._e(), _vm._v(" "), (_vm.showShare) ? _c('div', {
    staticClass: "share-box",
    on: {
      "click": _vm.bindShare
    }
  }, [_c('img', {
    staticClass: "share",
    attrs: {
      "src": require("./../assets/images/scholarships/share-icon.png")
    }
  })]) : _vm._e()]), _vm._v(" "), _c('AdTip')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86c1167a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1092
// module chunks = 85